import React, { useEffect } from 'react';
import classNames from 'classnames';
import styles from './stepGhostPresentationOnly.module.scss';

const StepGhost = ({ className, title }) => {
    return (
        <div className={styles.address}>
            <div className={classNames([styles.block, className])}>
                <span className={styles.title}>{title}</span>
            </div>
        </div>
    );
};

export default StepGhost;
